// Module
var code = "<a ng-click=\"navigate()\" id=\"tab-inprogress-link-large-screen\" class=\"tab-inprogress-link waves-effect waves-blue badge-todo-desktop\" data-badge=\"{{item.count()}}\" ng-class=\"{'hide-badge': item.count() === null || item.count() === undefined}\" ng-show=\"item.show()\"> <i class=\"{{item.icon}}\"></i> <div>{{item.name}}</div> </a> ";
// Exports
export default code;